"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEligibility = void 0;
const uuid_1 = require("uuid");
const formatEligibility = ({ borrowingBaseReportId, eligibilityTestResults, timestamp, }) => Array.from(eligibilityTestResults.values()).map((result) => (Object.assign(Object.assign({}, result), { id: (0, uuid_1.v4)(), borrowingBaseReportId, created_at: timestamp, updated_at: timestamp })));
exports.formatEligibility = formatEligibility;
//# sourceMappingURL=eligibility.js.map